<template>
	<component :is="component" v-if="component" />
</template>

<script>
export default {
	name: 'BaseHeaderComponent',
	props: {
		type: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			component: null
		}
	},
	computed: {
		loader() {
			if (!this.type) {
				return null;
			}
			return () => import(`./${this.type}`);
		}
	},
	mounted() {
		this.loader()
			.then(() => {
				this.component = () => this.loader();
			})
			.catch(() => {
				this.component = () => import(`./Base${this.type}`);
			});
	}
}
</script>

<style scoped></style>
